import { Message, SpecialOffer } from '../../../PdpProductProvider/types';
import { parseSpecialOffer } from './parseSpecialOffer';
import { PRODUCT_MESSAGE_TYPES } from '../../ProductMessages/utils/getProductMessages';

export const getSpecialOffersFromMessages = (
  messages?: Array<Message>,
  storeTimeZone?: string
): Array<SpecialOffer> => {
  const specialOffers: Array<SpecialOffer> = [];
  messages?.forEach(message => {
    if (
      ![PRODUCT_MESSAGE_TYPES.SERVICES, PRODUCT_MESSAGE_TYPES.SPECIAL_OFFERS].includes(message.type) ||
      message.subType === PRODUCT_MESSAGE_TYPES.INSTALLATION
    )
      return null;

    specialOffers.push(parseSpecialOffer(message, storeTimeZone));
  });
  return specialOffers;
};
